
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';

function Bestpicnicspotnearyavatmal() {



  const cardData =
  {
    keyword: ' Best Picnic Spot Near Yavatmal',
    heading:  'Woodland Escape: Best Picnic Spot Near Yavatmal ',
    headingDescription: 'Woodland Escape Resort is an excellent choice for the best picnic spot near Yavatmal, offering a serene natural setting with lush green lawns, forest-fringed open spaces, and a relaxed outdoor atmosphere just a short drive away. Whether you’re organising a family picnic, a gathering of friends, or a corporate outing, the resort provides plenty of comfortable spots for laying out picnic mats, enjoying light outdoor games, and taking scenic nature walks. With clean amenities, friendly staff, and a backdrop of trees and greenery that promotes peace and rejuvenation, Woodland Escape Resort near Yavatmal makes for a memorable, hassle-free picnic experience.',

    top: 'Top Activities of Woodland Escape Resort Near Nagpur',
   "topPlaces": [
  {
    "title": "Forest Retreat Stay Experience",
    "description": "Woodland Escape Resort offers a serene getaway surrounded by dense forests, misty hills, and soothing sounds of nature. Guests wake up to the melodies of chirping birds and the cool fragrance of dewy mornings. The resort blends rustic charm with modern elegance, creating an ambiance of true peace and comfort. Every corner reflects nature’s simplicity, encouraging travelers to disconnect from the city rush. Whether you’re lounging on the porch with a cup of tea or strolling through the green pathways, the stay promises calmness and clarity. It’s a retreat where you can breathe freely, unwind deeply, and reconnect with your natural rhythm."
  },
  {
    "title": "Luxury Cottages Amid Nature",
    "description": "The resort’s cottages are thoughtfully crafted to provide an authentic forest-luxury experience. Each cottage is built using eco-friendly materials and designed to offer panoramic views of the surrounding woods. Inside, guests enjoy spacious interiors, cozy bedding, and all modern amenities while staying close to nature’s essence. The gentle hum of the forest replaces city noise, offering a deeply restful environment. From sunrise reflections on your balcony to starry skies at night, every moment here feels timeless. Families, couples, and solo travelers alike find these cottages perfect for soulful relaxation amidst nature’s raw beauty."
  },
  {
    "title": "Wildlife and Tiger Safari",
    "description": "Adventure seekers can experience the thrill of the wild through guided tiger safaris organized near the resort. The region’s dense forests are home to majestic tigers, deer, peacocks, and countless species of birds. Expert naturalists accompany visitors, ensuring a safe and educational journey through the jungle. Each safari offers an adrenaline rush mixed with awe as you witness the raw beauty of wildlife in its natural habitat. The early morning and evening safaris are especially magical, when golden sunlight filters through the trees and animals emerge from their hiding places. It’s an unforgettable adventure that connects you to the untamed heart of nature."
  },
  {
    "title": "Nature Trails and Jungle Walks",
    "description": "For those who prefer calm exploration, Woodland Escape Resort’s nature trails offer the perfect adventure. Meandering paths take guests through wildflowers, bamboo groves, and hidden forest streams. Every step reveals something new — a bird call, a butterfly dance, or the gentle rustle of leaves. Guided jungle walks help you learn about the region’s biodiversity and plant life. It’s not just a walk; it’s an immersion into a living ecosystem that refreshes the mind and body. The experience is ideal for photographers, nature lovers, and families who want to reconnect with the wonders of the natural world."
  },
  {
    "title": "Campfire and Barbecue Nights",
    "description": "As dusk settles over the forest, Woodland Escape Resort transforms into a magical open-air lounge. Guests gather around the crackling bonfire, sharing laughter and stories under a canopy of stars. The aroma of freshly grilled barbecue fills the air, accompanied by light music and soft forest winds. Whether you’re roasting marshmallows with family or joining a live music night, the warmth of the fire unites everyone in celebration. This nightly ritual captures the essence of togetherness — blending fun, relaxation, and nature’s comfort into one unforgettable evening experience."
  },
  {
    "title": "Adventure and Outdoor Games",
    "description": "Beyond peaceful moments, the resort also offers a range of exciting outdoor adventures. Guests can try their hands at archery, cycling through forest trails, or rope-climbing challenges. A well-equipped outdoor arena allows for group sports like volleyball, cricket, and badminton. For thrill-seekers, there are guided treks and obstacle courses designed for team-building. Each activity encourages bonding, laughter, and energy in the fresh, open air. Whether you’re a corporate group or a family on vacation, the balance of fun and fitness ensures every guest finds their own rhythm of adventure."
  },
  {
    "title": "Farm-to-Table Dining Experience",
    "description": "Dining at Woodland Escape Resort is a celebration of freshness and local flavor. The restaurant follows a true farm-to-table concept, using ingredients sourced from nearby farms and organic gardens. Traditional Maharashtrian and regional delicacies are prepared with authentic recipes and served in an inviting outdoor dining area. Every meal tells a story — of farmers, tradition, and sustainability. The aroma of home-cooked food mingles with the crisp forest air, creating a soulful dining experience. Guests can even participate in small cooking sessions or farm tours to see where their food comes from."
  },
  {
    "title": "Peaceful Meditation and Yoga Zone",
    "description": "For those seeking inner peace, the resort’s meditation and yoga zone offers the perfect sanctuary. Set amidst greenery and birdsong, this space allows guests to practice mindfulness in complete harmony with nature. Morning yoga sessions at sunrise and guided evening meditations under the open sky restore balance and positivity. The calm surroundings, fresh oxygen, and gentle breezes make every breath rejuvenating. Many guests describe it as a spiritual escape where body, mind, and soul realign. Whether you’re an experienced yogi or a beginner, this serene corner helps you rediscover your inner calm."
  }
],



"services": [
    {
      "name": "Best Picnic Spot Near Yavatmal",
      "description": "Discover the best picnic spots near Yavatmal offering scenic landscapes, lush greenery, and tranquil surroundings. Ideal for friends and families looking to relax, enjoy nature, and spend quality time away from city life."
    },
    {
      "name": "Yavatmal Top Picnic Places",
      "description": "Explore the top picnic destinations in Yavatmal featuring beautiful gardens, riversides, and hills. These places provide perfect locations for photography, outdoor games, and leisurely walks amidst nature."
    },
    {
      "name": "Yavatmal Family Picnic Spot",
      "description": "Plan a fun-filled family picnic in Yavatmal at spots with kid-friendly activities, safe play areas, and cozy picnic zones. Enjoy bonding with family while surrounded by natural beauty and fresh air."
    },
    {
      "name": "Yavatmal Nature Picnic Spot",
      "description": "Reconnect with nature at Yavatmal’s serene picnic spots with dense greenery, rivers, and walking trails. Perfect for nature lovers seeking a peaceful retreat and a chance to unwind in a calm environment."
    },
    {
      "name": "Affordable Picnic Spot Yavatmal",
      "description": "Enjoy budget-friendly picnic options in Yavatmal that offer excellent amenities, picturesque surroundings, and convenient access without compromising on comfort and enjoyment."
    },
    {
      "name": "Yavatmal Weekend Picnic",
      "description": "Make your weekends special with picnic spots in Yavatmal designed for a full-day escape. Relax, explore, and engage in recreational activities that make your weekend refreshing and memorable."
    },
    {
      "name": "Yavatmal Riverside Picnic Spot",
      "description": "Spend a serene day by the riverside at Yavatmal picnic locations offering calm water views, picnic benches, and optional boating activities. Perfect for relaxing or enjoying a family lunch near flowing waters."
    },
    {
      "name": "Yavatmal Garden Picnic Spot",
      "description": "Visit Yavatmal’s lush garden picnic spots with well-maintained lawns, flower beds, and shaded areas. Ideal for photography, casual walks, and enjoying a peaceful day surrounded by vibrant flora."
    },
    {
      "name": "Yavatmal Hill Picnic Spot",
      "description": "Enjoy elevated views and fresh air at Yavatmal hill picnic spots. Trekking trails, scenic viewpoints, and natural landscapes make these locations perfect for adventure enthusiasts and nature lovers alike."
    },
    {
      "name": "Yavatmal Kids Friendly Picnic Spot",
      "description": "Choose Yavatmal picnic spots designed for children with safe play zones, swings, and interactive activities. Families can enjoy a worry-free outing while kids have plenty of fun."
    },
    {
      "name": "Yavatmal Scenic Picnic Spot",
      "description": "Capture breathtaking views at Yavatmal scenic picnic locations. With panoramic landscapes, photo-friendly spots, and natural beauty, these areas are perfect for memorable outings and photography."
    },
    {
      "name": "Yavatmal Outdoor Picnic Spot",
      "description": "Engage in outdoor activities like trekking, bird-watching, and games at Yavatmal picnic spots. These locations offer open spaces and recreational facilities for an active and enjoyable day in nature."
    },
    {
      "name": "Yavatmal Picnic Spot Booking",
      "description": "Easily book your preferred picnic spot in Yavatmal online. Secure tables, plan activities, and organize meals in advance to ensure a hassle-free and perfectly organized outing."
    },
    {
      "name": "Yavatmal Picnic Tour Packages",
      "description": "Opt for curated picnic tour packages in Yavatmal that include transport, guided tours, meal arrangements, and activity options. Ideal for groups or families seeking a complete and convenient picnic experience."
    },
    {
      "name": "Yavatmal Best Weekend Picnic Spot",
      "description": "Make weekends memorable at Yavatmal’s top picnic locations offering scenic beauty, fun activities, and relaxation opportunities. Perfect for short trips and family outings to recharge and enjoy nature."
    }
  ],
  "tableData": [
    ["- Best Picnic Spot Near Yavatmal", "- Yavatmal Top Picnic Places"],
    ["- Yavatmal Family Picnic Spot", "- Yavatmal Nature Picnic Spot"],
    ["- Affordable Picnic Spot Yavatmal", "- Yavatmal Weekend Picnic"],
    ["- Yavatmal Riverside Picnic Spot", "- Yavatmal Garden Picnic Spot"],
    ["- Yavatmal Hill Picnic Spot", "- Yavatmal Kids Friendly Picnic Spot"],
    ["- Yavatmal Scenic Picnic Spot", "- Yavatmal Outdoor Picnic Spot"],
    ["- Yavatmal Picnic Spot Booking", "- Yavatmal Picnic Tour Packages"],
    ["- Yavatmal Best Weekend Picnic Spot", ""]
  ],
  

whychoose: [
  {
    "WhyChooseheading": "Perfect Picnic Spot Near Wardha",
    "WhyChoosedescription": "Woodland Escape Resort is the ideal picnic destination near Wardha, offering families and friends a comfortable natural getaway for the day. With its open green lawns, gentle shade from trees, and a fresh‑air environment, it gives you a chance to step away from the city buzz and truly relax."
  },
  {
    "WhyChooseheading": "Tranquil Natural Environment",
    "WhyChoosedescription": "Tucked into a peaceful setting, the resort is surrounded by trees and natural landscapes that calm the mind. You’ll find the sounds of birds, rustling leaves and fresh breeze as the backdrop to your outing — perfect for unwinding, chatting and being together."
  },
  {
    "WhyChooseheading": "Spacious Picnic & Sit‑Out Areas",
    "WhyChoosedescription": "At Woodland Escape Resort you’ll find expansive lawn spaces and comfortable shaded sit‑outs where you can spread a blanket, share snacks, play light games or simply lounge under the trees. It’s designed so everyone—from kids to grandparents—can find their favourite spot."
  },
  {
    "WhyChooseheading": "Activities for All Ages",
    "WhyChoosedescription": "Whether you’re after a gentle nature walk, cycling along a quiet trail, pond‑side rest or a playful outdoor game, the resort accommodates all ages. It ensures that your picnic is not just about sitting around but about engaging, moving and enjoying together."
  },
  {
    "WhyChooseheading": "Delicious Meal Options & Refreshments",
    "WhyChoosedescription": "Complement your day out with freshly prepared local meals, snacks and beverages served on‑site. The resort’s food offerings ensure your picnic is not just comfortable, but also delightfully satisfying — no need to worry about packing everything from scratch."
  },
  {
    "WhyChooseheading": "Family‑Friendly & Safe Ambience",
    "WhyChoosedescription": "Designed with families in mind, Woodland Escape Resort offers a safe, welcoming environment where children can play, adults can relax and everyone can feel at ease. The atmosphere encourages bonding, laughter and calm moments under open skies."
  },
  {
    "WhyChooseheading": "Conveniently Located from Wardha",
    "WhyChoosedescription": "Just a short drive from Wardha, Woodland Escape Resort offers the convenience of accessibility combined with the feel of a nature escape. With less travel time you get more time to enjoy the day — the perfect formula for a picnic outing."
  }
]






















  }

const faqData = [
  {
    question: "Why choose Woodland Escape Resort as the best picnic spot near Yavatmal?",
    answer: "Woodland Escape Resort is ideally positioned as a top picnic destination near Yavatmal. Surrounded by natural greenery and well‑maintained lawns, it offers the perfect environment to relax, play and spend quality time with family and friends."
  },
  {
    question: "How far is Woodland Escape Resort from Yavatmal city?",
    answer: "The resort is located within comfortable driving distance from Yavatmal, making it an excellent choice for a day‑trip picnic or short outing without spending too much time on the road."
  },
  {
    question: "What activities can picnic visitors enjoy at Woodland Escape Resort?",
    answer: "Visitors can enjoy open lawns for games, shaded sitting areas, nature walks, cycling around the property, and comfortable picnic spots. The resort blends recreation with relaxation to make the day out memorable."
  },
  {
    question: "Is Woodland Escape Resort suitable for families and group picnics?",
    answer: "Absolutely! Woodland Escape Resort is family‑friendly and group‑friendly. With ample open space and safe surroundings, it’s an ideal spot for families, groups of friends and picnics with kids."
  },
  {
    question: "Does the resort provide meals or picnic‑packages for visitors?",
    answer: "Yes, Woodland Escape Resort offers freshly prepared meals, snacks and beverages. Picnic‑packages can include lunch and refreshments, so you can enjoy your day without worrying about food arrangements."
  },
  {
    question: "How can we book a picnic at Woodland Escape Resort near Yavatmal?",
    answer: "You can book by calling or sending a WhatsApp message to our reservation team, or by visiting the official website. Advance booking is recommended — especially for weekends and holidays — to secure your preferred date and space."
  }
];

const testimonials = [
  {
    name: "Mr. Vinod & Family, Yavatmal",
    text: "We had an amazing picnic at Woodland Escape Resort! The kids loved the open lawns and nature walk, and the food was excellent. Truly one of the best picnic spots near Yavatmal."
  },
  {
    name: "Ms. Shilpa & Friends, Yavatmal",
    text: "Our day out at Woodland Escape Resort was relaxing and fun! The setting was so green and calm, it made our picnic extra special. Highly recommend it for anyone near Yavatmal!"
  }
];






























      






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9175577266",

    ],
    email: "woodlandescape01@gmail.com"
  };


  const Images = [
  { place: "/images/keyword/1.jpg", text: "1 day tour near Nagpur", link: "1-day-tour-near-Nagpur" },
  { place: "/images/keyword/2.jpg", text: "Best picnic spot near Nagpur", link: "best-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/3.jpg", text: "Family picnic spot near Nagpur", link: "family-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/4.jpg", text: "Nearest picnic spot in Nagpur", link: "nearest-picnic-spot-in-Nagpur" },
  { place: "/images/keyword/5.jpg", text: "Destination wedding spots near Nagpur", link: "destination-wedding-spots-near-Nagpur" },
  { place: "/images/keyword/6.jpg", text: "Pre wedding destination near Nagpur", link: "pre-wedding-destination-near-Nagpur" },
  { place: "/images/keyword/7.jpg", text: "One day adventure resorts near Nagpur", link: "one-day-adventure-resorts-near-Nagpur" },
  { place: "/images/keyword/8.jpg", text: "Activities resort near Nagpur", link: "activities-resort-near-Nagpur" },
  { place: "/images/keyword/9.jpg", text: "Best picnic spot near Akola", link: "best-picnic-spot-near-Akola" },
  { place: "/images/keyword/10.jpg", text: "One day tour near Akola", link: "one-day-tour-near-Akola" },
  { place: "/images/keyword/11.jpg", text: "Resorts near Akola for family", link: "resorts-near-Akola-for-family" },
  { place: "/images/keyword/12.jpg", text: "Destination wedding resorts near Akola", link: "destination-wedding-resorts-near-Akola" },
  { place: "/images/keyword/13.jpg", text: "Best picnic spot near Amravati", link: "best-picnic-spot-near-Amravati" },
  { place: "/images/keyword/14.jpg", text: "One day tour near Amravati", link: "one-day-tour-near-Amravati" },
  { place: "/images/keyword/15.jpg", text: "Family resorts near Amravati", link: "family-resorts-near-Amravati" },
  { place: "/images/keyword/16.jpg", text: "Pre-wedding location near Amravati", link: "pre-wedding-location-near-Amravati" },
  { place: "/images/keyword/17.jpg", text: "Picnic spot near Bhandara", link: "picnic-spot-near-Bhandara" },
  { place: "/images/keyword/18.jpg", text: "One day trip near Bhandara", link: "one-day-trip-near-Bhandara" },
//   { place: "/images/keyword/19.jpg", text: "Resorts near Bhandara for family outing", link: "resorts-near-Bhandara-for-family-outing" },
//   { place: "/images/keyword/20.jpg", text: "Destination wedding place near Bhandara", link: "destination-wedding-place-near-Bhandara" },
//   { place: "/images/keyword/21.jpg", text: "Best picnic spot near Buldhana", link: "best-picnic-spot-near-Buldhana" },
//   { place: "/images/keyword/22.jpg", text: "One day tour near Buldhana", link: "one-day-tour-near-Buldhana" },
//   { place: "/images/keyword/23.jpg", text: "Family resorts near Buldhana", link: "family-resorts-near-Buldhana" },
//   { place: "/images/keyword/24.jpg", text: "Wedding destination near Buldhana", link: "wedding-destination-near-Buldhana" },
//   { place: "/images/keyword/25.jpg", text: "Picnic spot near Chandrapur", link: "picnic-spot-near-Chandrapur" },
];



  const images = [
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/2.jpg", alt: "Image 1" },
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/4.jpg", alt: "Image 1" },
    { src: "/images/galleryy/5.jpg", alt: "Image 1" },
    { src: "/images/galleryy/6.jpg", alt: "Image 1" },
    { src: "/images/galleryy/7.jpg", alt: "Image 1" },
    { src: "/images/galleryy/8.jpg", alt: "Image 1" },
    { src: "/images/galleryy/9.jpg", alt: "Image 1" },
  ];

const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Best Picnic Spot Near Yavatmal",
  "image": "https://woodlandescape.com/assets/images/yavatmal-picnic-spot.jpg",
  "description": "Discover the best picnic spot near Yavatmal at Woodlandescape Resort. Perfect for family outings, nature lovers, weekend getaways, riverside or hilltop picnics, and kids-friendly adventures.",
  "brand": {
    "@type": "Brand",
    "name": "Woodlandescape Resort"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "42"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "999",
    "availability": "https://schema.org/InStock",
    "url": "https://woodlandescape.com/best-picnic-spot-yavatmal"
  }
};




  return (
    <div>
<Helmet>
  <title>Best Picnic Spot Near Yavatmal | Woodlandescape Resort</title>
  <meta 
    name="description" 
    content="Visit Woodlandescape Resort, the best picnic spot near Yavatmal. Enjoy family-friendly outdoor activities, scenic nature spots, riverside and hilltop picnic experiences for a perfect weekend outing." 
  />
  <meta 
    name="keywords" 
    content="Best Picnic Spot Near Yavatmal, Yavatmal Top Picnic Places, Yavatmal Family Picnic Spot, Yavatmal Nature Picnic Spot, Affordable Picnic Spot Yavatmal, Yavatmal Weekend Picnic, Yavatmal Riverside Picnic Spot, Yavatmal Garden Picnic Spot, Yavatmal Hill Picnic Spot, Yavatmal Kids Friendly Picnic Spot, Yavatmal Scenic Picnic Spot, Yavatmal Outdoor Picnic Spot, Yavatmal Picnic Spot Booking, Yavatmal Picnic Tour Packages, Yavatmal Best Weekend Picnic Spot" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

   <section
  className="page-title"
  style={{
    backgroundImage: `
      linear-gradient(
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.6)
      ),
      url(/images/page-title.jpg)
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  <div className="auto-container">
    <div className="text-center">
            <h1>{cardData.keyword}</h1>
    </div>
  </div>
</section>

  


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-8 ">
              <img src='/images/keyword/44.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#2AA248', // green color
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className=' leadd'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>


              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div>

              </div>


            </div>

            <div className='col-12 col-md-4' >


              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #2AA248',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#2AA248' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 9175577266" className="d-block  text-white">+91 9175577266</a>

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:woodlandescape01@gmail.com" className=" text-white d-block">
                          woodlandescape01@gmail.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i> Woodland Escape Resort:<br />
                            Wadamba, Behind St. Peters School, Deolapar, Dist. Nagpur - <br />441401

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>


              {/* {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='darkcolorr'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })} */}


              
{Images.map((e, index) => {
  return (
    <div className="box1" key={index}>
      <a
        href={`/${e.link}`}
        className="d-flex justify-content-around align-items-center"
      >
        <div className="b1">
          <img src={e.place} alt={e.text} />
        </div>
        <div className="b2 darkcolorr">
          {e.text}
        </div>
      </a>
    </div>
  );
})}



             <Gallery images={images} ></Gallery>
              <table className="table table-responsive custom-table my-4">
                <thead>
                  <tr>
                    {cardData?.tableHeaders?.map((header, index) => (
                      <th key={index} className="custom-th">{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {cardData?.tableData?.map((row, rowIndex) => (
                    <tr className="custom-row" key={rowIndex}>
                      {row?.map((cell, cellIndex) => (
                        <td key={cellIndex} className="custom-td">
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for Woodland Escape Resort</h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>


              {/* <div className="contact-box Borderr mt-5">
                <h3>{contactData.heading}</h3>
                <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                <div className="contact-details">
                  <p><strong className='darkcolor'>Mobile No:</strong></p>
                  <ul>
                    {contactData.contactNumbers.map((number, index) => (
                      <li key={index}>
                        <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                          {number}
                        </a>
                      </li>
                    ))}
                  </ul>

                  <p><strong className='darkcolor'>Email Id: </strong>
                    <a href={`mailto:${contactData.email}`} className="contact-link">
                      {contactData.email}
                    </a>
                  </p>
                </div>
              </div> */}
<div className="contact-box woodland-theme mt-5">
  <h3 className="heading">{contactData.heading}</h3>
  <p className="subtext">
    For booking inquiries or any assistance, please feel free to contact us:
  </p>

  <div className="contact-details">
    <p className="label">📞 Mobile No:</p>
    <ul className="number-list">
      {contactData.contactNumbers.map((number, index) => (
        <li key={index}>
          <a href={`tel:${number}`} className="contact-link">
            {number}
          </a>
        </li>
      ))}
    </ul>

    <p className="label">📧 Email Id:</p>
    <a href={`mailto:${contactData.email}`} className="contact-link email-link">
      {contactData.email}
    </a>
  </div>
</div>



            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Bestpicnicspotnearyavatmal;